// extracted by mini-css-extract-plugin
export default {"title":"A_-z","warning":"B_-z","sizeOptionsLegendText":"C_-z"};